import React, { Fragment, useContext, useState, useEffect } from 'react';
import Spinner from '../../spinner/Spinner';
import SelectorSemana from '../../comunes/SelectorSemana';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faEnvelopeOpen
  ,faHandshake
  , faWalking
  , faLock
} from '@fortawesome/free-solid-svg-icons';
import ServicioContext from '../../../../context/servicio/servicioContext';
import AuthContext from '../../../../context/autentication/authContext';

const ReporteSemanalReducido = () => {
  const authContext = useContext(AuthContext);
  const { usuario } = authContext;

  const servicioContext = useContext(ServicioContext);
  const { loading, selectorUltSemanas, fnSelectorUltSemanas, fnReporteSemanalResumido,
          rsPeriodo, rsCorreosEnviados, rsOportunidades, rsSeguimientos, rsFinGestion} = servicioContext;

  const [semanaSeleccionada, setSemanaSeleccionada] = useState(0);
  const [carga, setCarga] = useState(false);

  useEffect(() => {
    if(carga === true) return;

    fnSelectorUltSemanas();
    setCarga(true);
    //eslint-disable-next-line
  }, []);
  //console.log(usuario.desc_usu_email);


  useEffect(() => {
    //console.log(semanaSeleccionada);
    if(semanaSeleccionada === 0) return;

    const datos = {
        usuario: usuario.desc_usu_email,
        idRut: usuario.id_usu_cliente,
        idSemana: semanaSeleccionada
    }

    fnReporteSemanalResumido(datos);
    //console.log(datos);
    //eslint-disable-next-line
  }, [semanaSeleccionada]);

  return (
    <Fragment>
      {
        (loading) ?
        <div className='spinner mt-5 pt-5'>
            <div className='col'>
                <Spinner />
                <h5 className='text-center mt-5'>Reporte en preparación. Esto puede tardar 90 segundos.</h5>
            </div>
        </div>
        :
        <div className='container mt-4'>
        <div className='row g-4'>
          <div className='col-12'>
            <div className='card-fondoColor bg-blanco p-3'>
              <div className='d-flex justify-content-between align-items-center'>
                <SelectorSemana 
                  loading = {loading}
                  usuario = {''}
                  fnSelectorUltSemanas = {fnSelectorUltSemanas}
                  selectorUltSemanas = {selectorUltSemanas}
                  semanaSeleccionada = {semanaSeleccionada}
                  setSemanaSeleccionada = {setSemanaSeleccionada}
                />
                <h5 className='pr-5 c-gris1'>{rsPeriodo.desc_periodo}</h5>
              </div>
            </div>
          </div>

                
                <div className='col-md-6'>
                  <div className='card-fondoColor bg-azulEP c-blanco mb-3'>
                    <div className='d-flex align-items-center'>
                        <div className='card-icon-fondoColor'>
                            <FontAwesomeIcon icon={faEnvelopeOpen} size='xs'/>
                        </div>
                        <div className='card-text-fondoColor ml-4'>
                            <div className='card-title-fondoColor'>Correos Enviados</div>
                            <div className='card-number-fondoColor'>{rsCorreosEnviados.f_opo_valor}</div>
                        </div>
                    </div>
                  </div> {/*Fin Tarjeta azulEP */}
                </div>

                <div className='col-md-6'>
                  <div className='card-fondoColor bg-verde2 c-blanco mb-3'>
                      <div className='d-flex align-items-center'>
                          <div className='card-icon-fondoColor'>
                              <FontAwesomeIcon icon={faHandshake} size='xs'/>
                          </div>
                          <div className='card-text-fondoColor ml-4'>
                              <div className='card-title-fondoColor'>Oportunidades</div>
                              <div className='card-number-fondoColor'>{rsOportunidades.f_opo_valor}</div>
                          </div>
                      </div>
                  </div> {/*Fin Tarjeta azulEP */}
                </div>

                <div className='col-md-6'>
                  <div className='card-fondoColor bg-naranjo2 c-blanco mb-3'>
                      <div className='d-flex align-items-center'>
                          <div className='card-icon-fondoColor'>
                              <FontAwesomeIcon icon={faWalking} size='sm'/>
                          </div>
                          <div className='card-text-fondoColor ml-5'>
                              <div className='card-title-fondoColor'>Seguimientos</div>
                              <div className='card-number-fondoColor'>{rsSeguimientos.f_opo_valor}</div>
                          </div>
                      </div>
                  </div> {/*Fin Tarjeta azulEP */}
                </div>

                <div className='col-md-6'>
                  <div className='card-fondoColor bg-indigo c-blanco mb-3'>
                      <div className='d-flex align-items-center'>
                          <div className='card-icon-fondoColor'>
                              <FontAwesomeIcon icon={faLock} size='sm'/>
                          </div>
                          <div className='card-text-fondoColor ml-5'>
                              <div className='card-title-fondoColor'>Fin Gestion</div>
                              <div className='card-number-fondoColor'>{rsFinGestion.f_opo_valor}</div>
                          </div>
                      </div>
                  </div> {/*Fin Tarjeta azulEP */}
                </div>
                
            </div>

        </div>

      }
      
    </Fragment>
  )
}

export default ReporteSemanalReducido;